export default {
	circleRadius: 3.5
};
